import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import _ from "lodash"; //lodash to do a deep comparison (optional)
import { getFromLocalStorage } from "../utils/local-storage";

const BetslipMonitor = ({ onBetslipChange, handleCombineOdds, live }) => {
  let bet1 = useSelector((state) => state.betting?.betslip);

  let betslip = getFromLocalStorage("betslip") ?? bet1;

  // console.log("onBetslipChanged what is betslip", onBetslipChange);

  useEffect(() => {
    if (betslip && Object.keys(betslip ?? {}).length > 0) {
      // Compare the current betslip with the previous betslip
      // Transform betslip data into viax structure
      const viaxBetslip = Object.values(betslip).map((bet) => ({
        externalEventId: bet.parent_match_id,
        externalMarketId: bet.sub_type_id,
        externalOutcomeId: bet.outcome_id,
        odd_value: bet.odd_value,
      }));

      // Create payload for callback
      const payload = {
        betslip: viaxBetslip,
        combinedOddsValue: handleCombineOdds(viaxBetslip),
      };
      // console.log("Payload to be sent to callback:", payload);

      // Call the callback with the transformed data
      if (onBetslipChange) {
        onBetslipChange(payload);
      }

      // Update the previousBetslip reference
    } else {
      const payload = {
        betslip: [],
        combinedOddsValue: 0,
      };

      console.log("Payload to be sent to callback:", payload);

      // Call the callback with the transformed data
      if (onBetslipChange) {
        onBetslipChange(payload);
      }
    }
  }, [betslip, onBetslipChange, handleCombineOdds, live]); // Re-run the effect if betslip or callback changes

  return null;
};

export default BetslipMonitor;
